import { db } from '../../src/main'

export default {
  initService: initService,
  loadDrawing: loadDrawing,
  saveDrawing: saveDrawing,
  saveEdit: saveEdit,
  deleteDrawing: deleteDrawing,
  saveItem: saveItem,
  saveUnit: saveUnit,
  saveColor: saveColor,
  setActiveRevision: setActiveRevision,
  fetchProjectKnowledgeBase: fetchProjectKnowledgeBase,
  saveEditItem: saveEditItem,
  saveEditColor: saveEditColor,
  pass: pass
}

var initialized = false
var currentProject = null
// listen to remote knowledge base change and keep it updated
var knowledgeBase = {
  projectId: null,
  colorBase: null,
  itemBase: null,
  unitBase: null
}

async function initService (projectId) {
  try {
    let result = initServiceTask(projectId)
    return result
  } catch (err) {
    console.warn(err)
  }
}

async function initServiceTask (projectId) {
  return new Promise((resolve, reject) => {
    if (currentProject === projectId && initialized) {
      // console.log('Already initialized')
      resolve(knowledgeBase)
    }
    // change init status
    // console.log(`initializing project => ${projectId}`)
    initialized = false
    currentProject = projectId
    // change knowledge base to unstable state
    knowledgeBase = {
      projectId: projectId,
      colorBase: null,
      itemBase: null,
      unitBase: null
    }

    let initItem = db.collection('items').where('projectId', '==', projectId).onSnapshot(querySnapshot => {
      let newItemBase = []
      querySnapshot.forEach(doc => {
        let item = doc.data()
        newItemBase.push(item)
      })
      knowledgeBase.itemBase = newItemBase

      // console.log('item base updated')
      return true
    })
    let initUnit = db.collection('units').where('projectId', '==', projectId).onSnapshot(querySnapshot => {
      let newUnitBase = []
      querySnapshot.forEach(doc => {
        let unit = doc.data()
        newUnitBase.push(unit)
      })
      knowledgeBase.unitBase = newUnitBase

      // console.log('unit base updated')
      return true
    })
    let initColor = db.collection('colors').where('projectId', '==', projectId).onSnapshot(querySnapshot => {
      let newColorBase = []
      querySnapshot.forEach(doc => {
        let color = doc.data()
        newColorBase.push(color)
      })
      knowledgeBase.colorBase = newColorBase

      // console.log('color base updated')
      return true
    })
    // init finished
    Promise.all([initItem, initUnit, initColor]).then(result => {
      initialized = true
      // console.log('Initialization finished!')
      resolve(true)
    }).catch(err => {
      reject(err)
    })
  })
}

async function loadDrawing (drawingId) {
  if (!drawingId) {
    return null
  }
  try {
    let drawingSnapshot = await db.collection('drawings').doc(drawingId).get()
    if (!drawingSnapshot.exists) {
      throw new Error('Drawing id not found')
    }
    let drawingData = drawingSnapshot.data()
    return drawingData
  } catch (err) {
    console.warn(err)
    return null
  }
}

async function setActiveRevision (drawingId) {
  let targetDrawingRef = db.collection('drawings').doc(drawingId)
  let result = {
    success: false,
    newRevision: ''
  }
  try {
    result.newRevision = await new Promise((resolve, reject) => {
      let newRevision = ''
      return db.runTransaction(t => {
        return t.get(targetDrawingRef).then(doc => {
          if (!doc.exists) {
            throw new Error('Target drawing not found')
          }
          t.update(targetDrawingRef, { activePage: true })
          let projectId = doc.data().projectId
          let pageId = doc.data().pageId
          newRevision = doc.data().revision
          return db.collection('drawings').where('projectId', '==', projectId).where('removed', '==', false).where('pageId', '==', pageId).get().then(querySnapshot => {
            querySnapshot.forEach(doc => {
              if (doc.data().drawingId !== drawingId) {
                // console.log('inactive one page')
                t.update(db.collection('drawings').doc(doc.data().drawingId), { activePage: false })
              }
            })
          })
        })
      }).then(() => {
        // console.log('Setting active revision success')
        resolve(newRevision)
      }).catch(err => {
        console.warn(err)
        reject(new Error(''))
      })
    })
    result.success = true
  } catch (err) {
    console.warn(err)
  }
  return result
}

async function saveDrawing (rawDrawing) {
  // get the latest knowledgeBase snap for faster indexing
  if (knowledgeBase.projectId !== rawDrawing.projectId) {
    // console.log('Pre-saving knowledge base fetch')
    await initService(rawDrawing.projectId)
  }
  // console.log(knowledgeBase)

  // get item id list for the drawing
  let itemList = []
  let itemIdList = []
  let projectId = rawDrawing.projectId
  for (var i = 0; i < rawDrawing.items.length; i++) {
    let rawItem = rawDrawing.items[i]
    let itemRef = {
      qty: rawItem.qty,
      remark: rawItem.remark
    }
    itemRef.itemId = await saveItem(rawItem, projectId)
    if (itemRef.itemId === '') {
      return false
    }
    let duplicateIndex = itemIdList.indexOf(itemRef.itemId)
    if (duplicateIndex === -1) {
      itemList.push(itemRef)
      itemIdList.push(itemRef.itemId)
    } else {
      itemList[duplicateIndex].qty += itemRef.qty
    }
  }

  // get unit list of the drawing
  let unitList = []
  for (var j = 0; j < rawDrawing.units.length; j++) {
    let rawUnit = rawDrawing.units[j]
    let unitId = await saveUnit(rawUnit, projectId)
    if (unitId === '') {
      return false
    }
    unitList.push(unitId)
  }

  // assemble the drawing data
  try {
    let stamp = String(Date.now())
    let drawing = {
      revision: rawDrawing.revision,
      updateDate: stampToString(stamp),
      updateStamp: stamp,
      note: rawDrawing.note,
      pageId: rawDrawing.pageId,
      type: rawDrawing.type,
      detailType: rawDrawing.detailType,
      removed: false,
      activePage: true,
      drawingId: stamp,
      projectId: rawDrawing.projectId,
      units: unitList,
      items: itemList,
      itemIds: itemIdList
    }
    // set the revision and other revision with same page id to not active
    let firestoreBatch = db.batch()
    let otherRevisions = await db.collection('drawings').where('projectId', '==', drawing.projectId).where('removed', '==', false).where('pageId', '==', drawing.pageId).get()
    otherRevisions.forEach(doc => {
      let testDrawing = doc.data()
      if (testDrawing.revision !== drawing.revision) {
        firestoreBatch.update(db.collection('drawings').doc(testDrawing.drawingId), {activePage: false})
      }
    })
    firestoreBatch.set(db.collection('drawings').doc(drawing.drawingId), drawing)
    await firestoreBatch.commit()
    return true
  } catch (err) {
    console.warn(err)
    return false
  }
}

async function saveEdit (rawDrawing, overwrite) {
  // overwrite will determine if the data will be saved to exist drawing in database.
  // If true, the drawing id in raw drawing will be used to save the drawing;
  // Otherwise, a new drawing id will be generated.

  // get the latest knowledgeBase snap for faster indexing

  // console.log(knowledgeBase)

  // get item id list for the drawing
  let itemList = []
  let itemIdList = []
  let projectId = rawDrawing.projectId
  for (var i = 0; i < rawDrawing.items.length; i++) {
    let rawItem = rawDrawing.items[i]
    let itemRef = {
      qty: rawItem.qty,
      remark: rawItem.remark
    }
    itemRef.itemId = await saveItem(rawItem, projectId)
    if (itemRef.itemId === '') {
      return false
    }
    let duplicateIndex = itemIdList.indexOf(itemRef.itemId)
    if (duplicateIndex === -1) {
      itemList.push(itemRef)
      itemIdList.push(itemRef.itemId)
    } else {
      itemList[duplicateIndex].qty += itemRef.qty
    }
  }

  // get unit list of the drawing
  let unitList = []
  for (var j = 0; j < rawDrawing.units.length; j++) {
    let rawUnit = rawDrawing.units[j]
    let unitId = await saveUnit(rawUnit, projectId)
    if (unitId === '') {
      return false
    }
    unitList.push(unitId)
  }

  // assemble the drawing data
  try {
    let stamp = String(Date.now())
    let drawing = {
      revision: rawDrawing.revision,
      updateDate: stampToString(stamp),
      updateStamp: stamp,
      note: rawDrawing.note,
      pageId: rawDrawing.pageId,
      type: rawDrawing.type,
      detailType: rawDrawing.detailType,
      removed: false,
      activePage: true,
      drawingId: overwrite ? rawDrawing.drawingId : stamp,
      projectId: rawDrawing.projectId,
      units: unitList,
      items: itemList,
      itemIds: itemIdList
    }
    // set the revision and other revision with same page id to not active
    let firestoreBatch = db.batch()
    let otherRevisions = await db.collection('drawings').where('projectId', '==', drawing.projectId).where('removed', '==', false).where('pageId', '==', drawing.pageId).get()
    otherRevisions.forEach(doc => {
      let testDrawing = doc.data()
      if (testDrawing.revision !== drawing.revision) {
        firestoreBatch.update(db.collection('drawings').doc(testDrawing.drawingId), {activePage: false})
      }
    })
    firestoreBatch.set(db.collection('drawings').doc(drawing.drawingId), drawing)
    await firestoreBatch.commit()
    return true
  } catch (err) {
    console.warn(err)
    return false
  }
}

async function deleteDrawing (drawingId) {
  if (!drawingId) {
    console.warn('drawingId must be provided!')
    return false
  }
  try {
    let firestoreBatch = db.batch()
    let drawing = await db.collection('drawings').doc(drawingId).get()
    let drawingData = drawing.data()
    let otherRevisions = await db.collection('drawings').where('projectId', '==', drawingData.projectId).where('removed', '==', false).where('pageId', '==', drawingData.pageId).get()

    // set another revision to active page if deleting target is active
    if (otherRevisions.size > 1 && drawingData.activePage) {
      for (let i = 0; i < otherRevisions.size; i++) {
        if (otherRevisions.docs[i].id !== drawingData.drawingId) {
          console.log(`set drawing ${otherRevisions.docs[i].id} (${otherRevisions.docs[i].data().pageId}, ${otherRevisions.docs[i].data().revision}) as new active version`)
          firestoreBatch.update(db.collection('drawings').doc(otherRevisions.docs[i].id), {activePage: true})
          break
        }
      }
    }
    firestoreBatch.update(db.collection('drawings').doc(drawingId), {removed: true})
    await firestoreBatch.commit()
    return true
  } catch (err) {
    console.warn(err)
    return false
  }
}

async function saveUnit (rawUnit, projectId) {
  // knowledgeBase is an optional param to help improve the searching speed by doing the search locally
  if (knowledgeBase.projectId !== projectId) {
    await initService(projectId)
  }
  // wait for unit base ready
  while (true) {
    if (knowledgeBase.unitBase !== null) {
      break
    }
    // check color base status in 0.1s
    await new Promise(resolve => {
      setTimeout(() => {
        resolve(null)
      }, 100)
    })
  }
  let unitId = searchUnitId(rawUnit, knowledgeBase.unitBase)
  if (unitId) {
    return unitId
  }

  // if no such unit yet
  let newUnitId = ''
  try {
    let stamp = String(Date.now())
    let newUnit = {
      unitId: stamp,
      projectId: projectId,
      display: rawUnit.display,
      building: rawUnit.building,
      floor: rawUnit.floor,
      tier: rawUnit.tier,
      type: rawUnit.type
    }
    await db.collection('units').doc(stamp).set(newUnit)
    newUnitId = stamp
  } catch (err) {
    console.warn(err)
  }
  return newUnitId
}

async function saveItem (rawItem, projectId) {
  // knowledgeBase is an optional param to help improve the searching speed by doing the search locally
  let rawColor = {
    name: rawItem.color,
    tag: rawItem.tag
  }
  let colorId = await saveColor(rawColor, projectId)
  rawItem.colorId = colorId
  if (knowledgeBase.projectId !== projectId) {
    await initService(projectId)
  }
  // wait for item base ready
  while (true) {
    if (knowledgeBase.itemBase !== null) {
      break
    }
    // check color base status in 0.1s
    await new Promise(resolve => {
      setTimeout(() => {
        resolve(null)
      }, 100)
    })
  }
  let itemId = searchItemId(rawItem, knowledgeBase.itemBase)
  if (itemId) {
    return itemId
  }
  // if no such item yet
  let newItemId = ''
  try {
    let stamp = String(Date.now())
    let newItem = {
      glide: 0,
      handle: 0,
      hinge: 0,
      projectId: projectId,
      itemId: stamp,
      model: rawItem.model,
      projectRemark: '',
      colorId: colorId
    }
    await db.collection('items').doc(stamp).set(newItem)
    newItemId = stamp
  } catch (err) {
    console.warn(err)
  }
  return newItemId
}

async function saveColor (rawColor, projectId) {
  // knowledgeBase is an optional param to help improve the searching speed by doing the search locally
  if (knowledgeBase.projectId !== projectId) {
    await initService(projectId)
  }
  // wait for color base ready
  while (true) {
    if (knowledgeBase.colorBase !== null) {
      break
    }
    // check color base status in 0.1s
    await new Promise(resolve => {
      setTimeout(() => {
        resolve(null)
      }, 100)
    })
  }
  let colorId = searchColorId(rawColor, knowledgeBase.colorBase)
  if (colorId) {
    return colorId
  }

  // if no such color yet (not returned above)
  let newColorId = ''
  try {
    let stamp = String(Date.now())
    let newColor = {
      tag: rawColor.tag,
      name: rawColor.name,
      colorId: stamp,
      projectId: projectId
    }
    await db.collection('colors').doc(stamp).set(newColor)
    newColorId = stamp
  } catch (err) {
    console.warn(err)
  }
  return newColorId
}

function searchItemId (targetItem, itemBase) {
  for (let item of itemBase) {
    if (targetItem.model === item.model && targetItem.colorId === item.colorId) {
      return item.itemId
    }
  }
  return ''
}

function searchUnitId (targetUnit, unitBase) {
  for (let unit of unitBase) {
    if (targetUnit.building === unit.building && targetUnit.floor === unit.floor && targetUnit.tier === unit.tier) {
      return unit.unitId
    }
  }
  return ''
}

function searchColorId (targetColor, colorBase) {
  for (let color of colorBase) {
    if (color.name === targetColor.name) {
      return color.colorId
    }
  }
  return ''
}

async function fetchProjectKnowledgeBase (projectId) {
  // console.log('Fetching project knowledge base')
  if (currentProject !== projectId) {
    await initService(projectId)
  }
  // wait for color base ready
  while (true) {
    if (knowledgeBase.colorBase !== null && knowledgeBase.itemBase !== null && knowledgeBase.unitBase !== null) {
      break
    }
    // check color base status in 0.1s
    await new Promise(resolve => {
      setTimeout(() => {
        resolve(null)
      }, 100)
    })
  }
  // console.log('knowledgeBase ready =>', knowledgeBase)

  return knowledgeBase
}

async function saveEditItem (itemForm) {
  // knowledgeBase is required when saving edited item
  let colorId = await saveColor(itemForm.color, itemForm.projectId)
  // console.log(colorId)

  try {
    let editedItem = JSON.parse(JSON.stringify(itemForm))
    delete editedItem.color
    editedItem.colorId = colorId
    await db.collection('items').doc(editedItem.itemId).set(editedItem)
    return true
  } catch (err) {
    console.warn(err)
    return false
  }
}

async function saveEditColor (colorData) {
  try {
    let editedColor = {
      colorId: colorData.colorId,
      name: colorData.name,
      projectId: colorData.projectId,
      tag: colorData.tag
    }
    await db.collection('colors').doc(editedColor.colorId).set(editedColor)
    return true
  } catch (err) {
    console.warn(err)
    return false
  }
}

function stampToString (stamp) {
  let dateObj = new Date(parseInt(stamp))
  let date = (dateObj.getDate() > 10 ? '' : '0') + dateObj.getDate()
  let month = (dateObj.getMonth() + 1 > 9 ? '' : '0') + (dateObj.getMonth() + 1)
  let year = dateObj.getFullYear()
  return `${year}-${month}-${date}`
}

function pass () {
  // console.log('Calling drawing.pass()')
  return true
}



//////////////////
// WEBPACK FOOTER
// ./static/js/drawing.js
// module id = null
// module chunks = 